export const GET_ERRORS = "GET_ERRORS";
export const USER_LOADING = "USER_LOADING";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_CURRENT_LESSON = "SET_CURRENT_LESSON";
export const SET_CURRENT_NAVIGATION = "SET_CURRENT_NAVIGATION";
export const SET_CURRENT_FURTHEST_LAB = "SET_CURRENT_FURTHEST_LAB";
export const SET_ACTIVE_LAB = "SET_CURRENT_ACTIVE_LAB";
export const SET_ACTIVE_TABLE = "SET_ACTIVE_TABLE";
export const SET_TABLE_KEY = "SET_TABLE_KEY";
export const SET_THEME = "SET_THEME";